/* eslint-disable */


import Vue from 'vue';
import App from './App';
import router from './router';
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import "babel-polyfill"
import Cookies from 'js-cookie';
import NProgress  from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/common/store/';
import vueg from 'vueg-history'
import i18n from './i18n/i18n'
import { axios, urls } from '@/common/index';
import './libs/gt4.js';




import 'swiper/dist/css/swiper.css'



import '@/common/rem/rem.js'
import './style/base.css'
import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards);
Vue.use(AlertPlugin,{position: 'middle'})
const options = {
duration:'0.3',					//转场动画时长,默认为0.3,单位秒
firstEntryDisable:false,		//值为true时禁用首次应用的渐现动画,默认为false
firstEntryDuration:'.6',		//首次进入应用时的渐现时长,默认为.6
forwardAnim:'fadeInRight',		//前进动画,默认为fadeInRight
backAnim:'fadeInLeft',			//后退动画,默认为fedeInLeft
sameDepthDisable:false,			//url深度相同时禁用动画,默认为false
tabs:[],								//默认为[],name对应路由的name,一实现类似app中的tab页面水平转场效果,如果tab[1]到tab[0],会使用backAnim动画,tab[1]到tab[2],会使用forwardAnim动画
tabsDisable:false,				//值为true时,tabs间的转场没有动画,默认为false
disable:false,					//禁用转场动画,默认为false,嵌套路由默认为true
}
Vue.use(vueg, router, options)

NProgress.configure({
easing: 'ease',  // 动画方式
speed: 500,  // 递增进度条的速度
showSpinner: false, // 是否显示加载ico
trickleSpeed: 200, // 自动递增间隔
minimum: 0.3 
})



Vue.config.productionTip = false;

Vue.prototype.$Cookies = Cookies;

Vue.prototype.$project = '922';
Vue.prototype.$api = axios;
Vue.prototype.$urls = urls;







import { switchCase, toFixed, strEncryption, moneyFilter } from '@/common/filter/index.js'
import { parseTime } from '@/common/utils/Date.js'
Vue.filter("switchCase", switchCase)
Vue.filter("ToFixed", toFixed)
Vue.filter("strEncryption", strEncryption)
Vue.filter("parseTime", parseTime)
Vue.filter("moneyFilter", moneyFilter)



import GL_Component from "./utils/globalComponent.js"
Vue.use(GL_Component);


import GL_ui from "./utils/global-ui.js"
Vue.use(GL_ui)

import limitNum from '@/common/directive/onlyNum'
Vue.directive('limitNum', limitNum)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
i18n,
components: { App },
template: '<App/>',
});



router.afterEach(() => {

NProgress.done()
})



// WEBPACK FOOTER //
// ./src/pages/build922/build922.js